var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"award-badges"},_vm._l((_vm.badges),function(badge){return _c('div',{key:badge.id},[_c('award-badge',{attrs:{"badge":badge,"awarded-at":_vm.badge_awarded_at(badge),"size":_vm.size}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }